import React, { useEffect, useState } from 'react';
import NavbarLive from './NavbarLive';
import Loader from '../../components/Loader';
import Calling from '../../api/Calling';
import { toast } from 'react-toastify';
import DeleteButton from '../../components/ul/DeleteButton';
import generateCaptcha from '../../components/captcha';
import { useNavigate } from 'react-router-dom';
const LiveMatchAdWeb = () => {
    const [loader, setLoader] = useState(false);
    const [adsData, setAdsData] = useState([]);
    const [editingAd, setEditingAd] = useState(null); // Track the ad being edited
    const [showAddForm, setShowAddForm] = useState(false);
    const [newAd, setNewAd] = useState({ a_name: '', a_url: '' });
    const navigate = useNavigate();
    const fetchData = async () => {
        setLoader(true);
        try {
            const resp = await Calling.getAllLiveMatchAdWeb();
            if (resp?.status) {
                setAdsData(resp?.data);
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleEdit = (ad) => {
        setEditingAd({ ...ad }); // Clone the ad to allow editing
    };

    const handleChange = (key, value) => {
        setEditingAd((prev) => ({ ...prev, [key]: value }));
    };

    const handleSave = async () => {
        if (!editingAd?._id) return;

        setLoader(true);
        try {
            const body = {
                _id: editingAd._id,
                a_name: editingAd.a_name,
                a_url: editingAd.a_url
            };
            const resp = await Calling.editLiveMatchAdWeb(body);

            if (resp?.status) {
                toast.success("Ad updated successfully!");
                fetchData();
                setEditingAd(null); // Exit edit mode
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
            toast.error('Error updating ad.');
        } finally {
            setLoader(false);
        }
    };

    const handleFire = async (name, url) => {
        if (name.trim() === '') {
            toast.error('Please fill all the fields');
            return;
        }
        setLoader(true);
        let Adstype = {}
        if (name == "Open_Ads_Fire") {
            Adstype = "Open_Ads_Fire"
        } else if (name == "NTV_Ads_Fire") {
            Adstype = "NTV_Ads_Fire"
        } else {
            Adstype = "Url_Ads_Fire"
        }
        try {
            const body = {
                Adstype: Adstype,
                a_name: name.trim(),
                url: url.replace(/ /g, '')
            };

            const resp = await Calling.fireLiveMatchAdWeb(body);

            if (resp?.status) {
                toast.success(resp?.message);
                fetchData();
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    };

    const handleAddSubmit = async () => {
        if (newAd.a_name.trim() === '' || newAd.a_url.trim() === '') {
            toast.error('Please fill all the fields');
            return;
        }

        setLoader(true);
        try {
            const body = {
                a_name: newAd.a_name.replace(/ /g, ''),
                a_url: newAd.a_url.replace(/ /g, '')
            };
            const resp = await Calling.addLiveMatchAdWeb(body);

            if (resp?.status) {
                toast.success(resp?.message);
                setNewAd({ a_name: '', a_url: '' });
                setShowAddForm(false);
                fetchData();
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    };
    const handleDelete = async (id) => {
        setLoader(true);
        try {
            const content = `You are about to delete Story. To confirm, please solve this math problem`
            const check = generateCaptcha(content);
            if (check) {
                const body = {
                    id: [id]
                }

                const response = await Calling.deleteLiveMatchAdWeb(body);
                const { status, message } = response;
                if (status) {
                    toast.success(message, { autoClose: 2000 });
                    fetchData();
                } else {
                    toast.error(message, { autoClose: 2000 });
                }
            } else {
                toast.error("Ans in not currect", { autoClose: 2000 });

            }
        } catch (error) {
            console.log(error);
            navigate('/Error');
        } finally {
            setLoader(false);
        }
    }

    return (
        <>
            {loader ? (
                <Loader loader={loader} />
            ) : (
                <div className="px-3 sm:ml-[4.4rem] w-full md:mt-20 mt-16 overflow-hidden">
                    <div className="w-full mt-4 mb-2"><h1 className="text-xl sm:text-2xl font-bold">Live Match Management</h1></div>
                    <div className='bg-main-white rounded-xl shadow-md'>
                        <NavbarLive selectState={'adsFire'} />
                        <hr className='mt-2 bg-main-border border-[1px]' />

                        {/* Add Web Ads Section */}
                        <div className='px-6 pt-6'>
                            <div className='flex justify-between items-center mb-5'>
                                <h1 className='text-2xl font-bold text-main-font'>Website Ads</h1>
                                <button
                                    onClick={() => setShowAddForm(!showAddForm)}
                                    className='px-3 py-2 text-md text-main-white bg-green-600 rounded-3xl hover:bg-green-700'
                                >
                                    + Add Web Ads
                                </button>
                            </div>
                            {showAddForm && (
                                <div className="mt-6 p-4 rounded-lg space-y-4 bg-main-bg">
                                    <div className='grid grid-cols-1 sm:grid-cols-12 gap-2 items-center'>
                                        <input
                                            type="text"
                                            placeholder="Ad Name"
                                            value={newAd.a_name}
                                            onChange={(e) => setNewAd({ ...newAd, a_name: e.target.value })}
                                            className='col-span-5 p-2 border border-main-border rounded'
                                        />
                                        <input
                                            type="text"
                                            placeholder="Ad URL"
                                            value={newAd.a_url}
                                            onChange={(e) => setNewAd({ ...newAd, a_url: e.target.value })}
                                            className='col-span-5 p-2 border border-main-border rounded'
                                        />
                                        <button
                                            onClick={handleAddSubmit}
                                            className='col-span-2 px-3 py-2 text-md text-main-white bg-main-blue rounded hover:bg-main-blue/80 transition'
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        <hr className='mt-2 bg-main-border border-[1px]' />
                        {/* Ads List Section */}
                        <div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 mt-4 pb-6 px-4'>
                            {adsData.map((ad, index) => (
                                <div key={index} className='flex flex-col p-3 shadow-md rounded-lg border border-gray-200 '>

                                    {/* Name */}
                                    <div className='flex items-center gap-4'>
                                        <label className='text-sm font-semibold text-main-subfont'>Name</label>
                                        {editingAd?._id === ad._id ? (
                                            <input
                                                type='text'
                                                value={editingAd.a_name || ''}
                                                onChange={(e) => handleChange('a_name', e.target.value)}
                                                className='w-full p-2 border rounded-lg'
                                            />
                                        ) : (
                                            <span className='text-main-font'>{ad.a_name}</span>
                                        )}
                                    </div>

                                    {/* URL */}
                                    {ad?.a_name != "Open_Ads_Fire" && ad?.a_name != "NTV_Ads_Fire" ? (
                                        <div className='flex items-center gap-4 mt-2'>
                                            <label className='text-sm font-semibold text-main-subfont'>URL</label>
                                            {(editingAd?._id === ad._id) ? (
                                                <input
                                                    type='text'
                                                    value={editingAd.a_url || ''}
                                                    onChange={(e) => handleChange('a_url', e.target.value)}
                                                    className='w-full p-2 border rounded-lg ml-2'
                                                />
                                            ) : (
                                                <span className='text-main-font ml-2'>{ad.a_url}</span>
                                            )}
                                        </div>
                                    ) : ''
                                    }

                                    {/* Buttons */}
                                    <div className='flex justify-end mt-3 gap-4'>
                                        {editingAd?._id === ad._id ? (
                                            <>

                                                <button
                                                    onClick={handleSave}
                                                    className='px-3 py-2 text-sm text-main-white bg-green-500 rounded'
                                                >
                                                    Save
                                                </button>
                                                <button
                                                    onClick={() => setEditingAd(null)}
                                                    className='px-3 py-2 text-sm text-main-white bg-gray-400 rounded'
                                                >
                                                    Cancel
                                                </button>
                                                <DeleteButton
                                                    onClick={() => handleDelete(ad?._id)}
                                                />
                                            </>
                                        ) : (
                                            ad?.a_name === "Open_Ads_Fire" || ad?.a_name === "NTV_Ads_Fire" ? (
                                                <>
                                                    <button
                                                        onClick={() => handleFire(ad?.a_name, ad?.a_url)}
                                                        className='px-3 py-2 text-sm text-main-white bg-red-500 rounded'
                                                    >
                                                        Fire
                                                    </button>
                                                </>
                                            ) :
                                                (<>
                                                    <button
                                                        onClick={() => handleEdit(ad)}
                                                        className='px-3 py-2 text-sm text-main-white bg-blue-500 rounded'
                                                    >
                                                        Edit
                                                    </button>
                                                    <button
                                                        onClick={() => handleFire(ad?.a_name, ad?.a_url)}
                                                        className='px-3 py-2 text-sm text-main-white bg-red-500 rounded'
                                                    >
                                                        Fire
                                                    </button>
                                                </>)
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default LiveMatchAdWeb;
